import type { IHardwareOverviewItem } from '../model/hardwareOverviewItem';

export const getTableSort = (data?: Array<IHardwareOverviewItem>, sortByFacility?: string) => {
  if (data?.length && sortByFacility) {
    return [...data].sort((a, b) =>
      sortByFacility === 'asc' ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name),
    );
  }

  return data;
};
